import _ from "lodash";
import { pollAccommodationSearch } from "../../api";
import { PACKAGE_ACC_POLL_SAVE } from "./types";
import { destAccResultsUpdatedSelector } from "../../umbilical_hocs";
import {
  checkPackagePriceSearch,
  pkgFailedSearch,
  pkgUpdateServiceSearchStatus,
} from ".";
import {
  ACCOMMODATION_SEARCH_FORM_CHANGE,
  ACCOMMODATION_SEARCH_FORM_RESET,
  ACCOMMODATION_SEARCH_FORM_UPDATE,
} from "../single_search/types";

// ==================== ACC SEARCH FORM ==========================
export function accSearchFormReset() {
  return { type: ACCOMMODATION_SEARCH_FORM_RESET };
}

export function accSearchFormChange(key, value) {
  return { type: ACCOMMODATION_SEARCH_FORM_CHANGE, key, value };
}

export function accSearchFormUpdate({ form }) {
  return { type: ACCOMMODATION_SEARCH_FORM_UPDATE, form };
}

// ===============================================================
const saveAccPollResult = ({ dest_order, data, status }) => {
  return { type: PACKAGE_ACC_POLL_SAVE, dest_order, data, status };
};

const updateAccSearchStatus =
  ({ search_sessions }) =>
  (dispatch, getState) => {
    const state = getState();
    const updates = [];
    for (let idx in search_sessions) {
      const session = search_sessions[idx];
      const { dest_order } = session;

      const isUpdated = destAccResultsUpdatedSelector(state, { dest_order });
      updates.push(isUpdated);

      if (isUpdated) {
        dispatch(
          pkgUpdateServiceSearchStatus({
            srvType: "accommodation",
            dest_order,
            status: false,
          })
        );
      }
    }

    if (updates.every((status) => status)) {
      dispatch(checkPackagePriceSearch());
    } else {
      dispatch(pkgFailedSearch());
    }
  };

export const accommodationsSearchPoller =
  ({ pollCount }) =>
  async (dispatch, getState) => {
    const state = getState();
    const acc_sessions = _.get(
      state,
      "TourPriceInfo.search_data.search_statuses.accommodation",
      {}
    );

    const maxPollCount = 7;
    if (maxPollCount < pollCount) {
      dispatch(updateAccSearchStatus({ search_sessions: acc_sessions }));
      return;
    }

    const responses = [];
    var accommodationsFound = 0;
    for (let idx in acc_sessions) {
      const session = acc_sessions[idx];
      const { dest_order } = session;
      const { accommodation_id } = session;

      const poll_response = await pollAccommodationSearch({
        session_id: session.session_id,
        result_id: accommodation_id,
      });

      responses.push(poll_response);

      if (_.get(poll_response, "results", []).length > 0) {
        const selectedAcc = poll_response.results.find(
          (acc) => acc.metadata.id.toString() === accommodation_id.toString()
        );

        if (!selectedAcc) {
          continue;
        }
        accommodationsFound += 1;

        selectedAcc["selected"] = true;
        selectedAcc.rooms[0]["selected"] = true;
        await dispatch(
          saveAccPollResult({
            dest_order,
            data: _.cloneDeep(poll_response.results),
            status: poll_response.status === "working",
          })
        );
      }
    }

    const someAccNotFound = accommodationsFound !== acc_sessions.length;

    const someSessionIsSearching =
      responses.length && responses.some((resp) => resp.status === "working");
    if (someAccNotFound || someSessionIsSearching) {
      const newPollCount = pollCount + 1;
      setTimeout(
        () => dispatch(accommodationsSearchPoller({ pollCount: newPollCount })),
        2000
      );
    } else {
      dispatch(updateAccSearchStatus({ search_sessions: acc_sessions }));
    }
  };
